/**
* Before and After Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Before and After Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'before-and-after-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );
      $( '.before-after-slider-outer' ).slick( {
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        appendArrows: $( '.before-after-nav-wrapper' ),
        prevArrow: '<button type="button" class="text-brand-off-white hover:text-brand-corduroy duration-300"><svg class="icon icon-primary-arrow-left mb-1 mr-1"><use xlink:href="#icon-primary-arrow-left"></use></svg> Previous</button>',
        nextArrow: '<button type="button" class="text-brand-off-white hover:text-brand-corduroy duration-300">Next <svg class="icon ml-1 mb-1 icon-primary-arrow"><use xlink:href="#icon-primary-arrow"></use></svg></button>',
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'before-and-after-slider', COMPONENT );
} )( app );
